import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import CloseButton from './CloseButton'

const Header = ({ children, onClose, className }) => (
  <header className={classnames('flex w-full', className)}>
    {children}
    <CloseButton onClose={onClose} />
  </header>
)

Header.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  onClose: PropTypes.func,
  showIcon: PropTypes.bool,
}

Header.defaultProps = {
  showIcon: false,
  classNames: {},
}

export default Header
